import { Text } from "@mantine/core"
import {
  IconAdjustments,
  IconExternalLink,
  IconLogout,
  IconUserEdit,
} from "@tabler/icons-react"
import { Button, AppLanguageMenu, AppHeader, UserMenu, MenuItem } from "@tfg/ui"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { Locale } from "@tfg/types/schemas/enum"

import { SUPPLIER_LOCALES } from "~/i18n"
import { useAuth } from "~/store/auth-context"
import { findLanguage, findLanguageFlag } from "~/utils/languages.tsx"

const useGetSupplierLinkItems = () => {
  const { t } = useTranslation()
  return [
    {
      label: t("supplier.menu.requests"),
      link: "/supplier/requests/traceability",
    },
    {
      label: t("supplier.menu.supplierRequests"),
      link: "/supplier/traceability",
    },
    {
      label: t("supplier.menu.productionSites"),
      link: "/supplier/production-sites",
    },
    {
      label: t("supplier.menu.contacts"),
      link: "/supplier/contacts",
    },
  ]
}

export const SupplierAppHeader = () => {
  const { t, i18n } = useTranslation()
  const { user, logout, isAdmin } = useAuth()
  const navigate = useNavigate()

  const supplierMenuItems: MenuItem[] = [
    {
      label: t("menus.profile"),
      icon: <IconUserEdit size="1rem" />,
      onClick: () => navigate("/profile"),
    },
    {
      label: t("menus.logout"),
      icon: <IconLogout size="1rem" />,
      onClick: () => logout(),
    },
  ]

  const adminItem: MenuItem | null = isAdmin
    ? {
        label: i18n.t("menus.admin"),
        icon: <IconAdjustments size="1rem" />,
        onClick: () => navigate("/admin"),
      }
    : null

  if (adminItem) supplierMenuItems.splice(-1, 0, adminItem)

  const navItems = useGetSupplierLinkItems()
  if (!user) return null
  return (
    <AppHeader theme="supplier" navItems={navItems}>
      <AppLanguageMenu
        currentLocale={findLanguage(i18n.language.toUpperCase())}
        handleLanguageChange={async (locale) => {
          await i18n.changeLanguage(locale)
        }}
        languageItems={SUPPLIER_LOCALES.map((locale) => ({
          label: findLanguage(locale.toUpperCase()),
          value: locale,
          icon: findLanguageFlag(locale.toUpperCase() as Locale),
        }))}
      />
      <Button
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.notion.so/FAQ-Trace-for-Good-b51abcfa27e94403a27449d96327a984?pvs=4"
        rightSection={<IconExternalLink size="1rem" />}
        variant="tertiary"
      >
        <Text>{t("supplier.menu.documentation")}</Text>
      </Button>
      <UserMenu user={user} menuItems={supplierMenuItems} withAvatar={false} />
    </AppHeader>
  )
}
